// src/pages/DeliveryStatus/components/NewStatus.jsx
import React, { useEffect, useState, useCallback } from "react";
import { Table, Pagination } from "antd";
import OrderStatusFullInfo from "./OrderStatusFullInfo";
import {
  AcceptDocumentsForDeliveryButton,
  CompleteDeliveryButton,
} from "./DeliveryActionModal";
import { fetchStatuses } from "../utils/fetch";
import {
  getOrderStatusDataSource,
  orderStatusColumnsNew,
} from "../utils/table";

const NewStatus = ({ userPermission, query = "" }) => {
  const [leads, setLeads] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalCount, setTotalCount] = useState(0);

  const loadData = useCallback(
    (page = 1, size = limit) => {
      setIsLoading(true);
      return fetchStatuses(
        "ACTIVE",
        ["READY_FOR_SHIPMENT", "ON_DELIVERY"],
        query,
        setLeads,
        setIsLoading,
        setTotalCount,
        page,
        size
      ).then(({ currentPage: cp }) => {
        setCurrentPage(cp);
        setLimit(size);
      });
    },
    [query, limit]
  );

  useEffect(() => {
    loadData(1, limit);
  }, [query, loadData, limit]);

  const handlePageChange = (page, size) => {
    loadData(page, size);
  };

  // готовим строки через утилиту
  const dataSource = getOrderStatusDataSource(
    leads,
    () => loadData(currentPage, limit)
  );

  // однократный столбец действий
  const columns = [
    ...orderStatusColumnsNew.filter((c) => c.key !== "actions"),
    {
      title: "Действия",
      key: "actions",
      fixed: "right",
      width: 180,
      render: (_, record) => {
        const { status, isHasDelivery } = record.data;
        return (
          <>
            {status === "READY_FOR_SHIPMENT" && isHasDelivery && (
              <AcceptDocumentsForDeliveryButton
                lead={record.data}
                refresh={() => loadData(currentPage, limit)}
              />
            )}
            {status === "ON_DELIVERY" && isHasDelivery && (
              <CompleteDeliveryButton
                lead={record.data}
                refresh={() => loadData(currentPage, limit)}
              />
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <Table
        size="small"
        bordered
        loading={isLoading}
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        scroll={{ y: 500 }}
        expandable={{
          expandedRowRender: (record) => (
            <OrderStatusFullInfo
              data={record.data}
              userPermission={userPermission}
            />
          ),
        }}
      />

      <div style={{ marginTop: 16, textAlign: "center" }}>
        <Pagination
          current={currentPage}
          total={totalCount}
          pageSize={limit}
          showSizeChanger
          pageSizeOptions={["10", "20", "50"]}
          onChange={handlePageChange}
          onShowSizeChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default NewStatus;
